import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#faf5eb] py-20 md:py-32" data-id="element-135">
      <div className="max-w-4xl mx-auto px-6" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-800" data-id="element-137">
          <p className="italic text-2xl md:text-3xl text-[#0f172a] font-serif" data-id="element-138">
            Son las 3:14 AM.
          </p>

          <p data-id="element-139">
            Estás despierta otra vez, con el calor subiendo por tu pecho y una
            lista interminable de pendientes dando vueltas en tu cabeza. Miras
            el reloj y haces el cálculo mental:{' '}
            <span className="font-semibold" data-id="element-140">
              "Si me duermo ahora, solo me quedan 4 horas".
            </span>
          </p>

          <p data-id="element-141">
            La frustración es real. Sientes que tu cuerpo te está traicionando y
            sabes que mañana estarás de mal humor, agotada y sobreviviendo a
            base de café.
          </p>
        </motion.div>
      </div>
    </section>;
}